<template>
  <div class="list">
    <el-button style="margin-bottom: 5px" :loading="exportLoading" type="primary" @click="exportExcel()"> 导出 </el-button>
    <div style="margin-bottom: 8px">
      <vm-search label="单据类型">
        <el-select v-model="filter.formName" placeholder="请选择" @change="formNameChange">
          <el-option v-for="item in typeList" :key="item.formID" :label="item.formText" :value="item.formName"/>
        </el-select>
      </vm-search>
      <vm-search label="处理节点">
        <el-select v-model="filter.nodeText" clearable placeholder="请选择处理节点">
          <el-option v-for="item in nodeList" :key="item.approveNodeID" :label="item.descrpt" :value="item.approveNodeID"/>
        </el-select>
      </vm-search>
      <vm-search label="处理结果">
        <el-select v-model="filter.handleResult" clearable placeholder="请选择">
          <el-option v-for="item in handleList" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
      </vm-search>
      <vm-search label="处理人">
        <el-input v-model.trim="filter.handlerName" placeholder="请输入处理人姓名" style="width: 150px" clearable/>
      </vm-search>
      <vm-search label="单据编号">
        <el-input v-model.trim="filter.billNo" placeholder="请输入单据编号" style="width: 150px" clearable/>
      </vm-search>
      <vm-search label="处理日期">
        <el-date-picker
            v-model="filter.handledTimeStart"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 100%"
            placeholder="选择开始日期"
        />
      </vm-search>
      <vm-search label="至">
        <el-date-picker
            v-model="filter.handledTimeEnd"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 100%"
            placeholder="选择结束日期"
        />
      </vm-search>
      <vm-search v-if="filter.formName === 'SaleOrder'" label="关键字" :label-width="67">
        <el-input v-model.trim="filter.filter" placeholder="请输入关键字" style="width: 150px" clearable/>
      </vm-search>
      <div style="display: flex; flex-direction: row; height: 28px; float: right">
        <div class="ad-search-btn">
          <el-button type="primary" size="mini" style="margin-bottom: 1%; margin-left: 5px" @click="handleSearchClick"> 查询 </el-button>
        </div>
      </div>
    </div>
    <el-table
        v-if="filter.formName === 'SaleOrder'"
        v-loading="status === 'loading'"
        border
        height="75vh"
        :data="tableData"
        style="width: 100%"
    >
      <template slot="empty">
        <i v-if="status === 'loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status === 'error'" @click="handleSearchClick">加载失败，点击重新获取</el-button>
        <div v-else-if="status === 'empty'">暂无数据</div>
      </template>
      <el-table-column prop="billNO" label="单据编号" width="140"/>
      <el-table-column prop="customerName" label="客户名称" min-width="240"/>
      <el-table-column prop="creatorName" width="100" label="制单人" align="center"/>
      <el-table-column prop="statusName" label="状态" width="140"/>
      <el-table-column prop="handleResultText" width="100" label="处理结果" align="center"/>
      <el-table-column prop="handlerName" label="处理人" align="center"/>
      <el-table-column prop="nodeText" width="140" label="节点"/>
      <el-table-column prop="handleTime" width="150" label="处理时间" align="center"/>
      <el-table-column prop="domesticText" label="项目类型"/>
      <el-table-column prop="includeControlBoxText" label="含控制柜"/>
      <el-table-column prop="dqTechComplexity" width="160" label="电气评审复杂度"/>
      <el-table-column prop="bjTechComplexity" width="160" label="部件评审复杂度"/>
    </el-table>
    <el-table
        v-else-if="filter.formName === 'BusinessApplication'"
        v-loading="status === 'loading'"
        height="75vh"
        :data="tableData"
        style="width: 100%"
        border
    >
      <template slot="empty">
        <i v-if="status === 'loading'" class="el-icon-loading" style="font-size: 18px"/>
        <el-button v-else-if="status === 'error'" @click="handleSearchClick">加载失败，点击重新获取</el-button>
        <div v-else-if="status === 'empty'">暂无数据</div>
      </template>
      <el-table-column prop="billNO" label="单据编号" width="140" align="center"/>
      <el-table-column prop="customerName" label="客户名称" min-width="240"/>
      <el-table-column prop="creatorName" width="100" label="制单人" align="center"/>
      <el-table-column prop="statusName" label="状态" width="140"/>
      <el-table-column prop="handleResultText" width="100" label="处理结果" align="center"/>
      <el-table-column prop="handlerName" label="处理人" width="100" align="center"/>
      <el-table-column prop="nodeText" width="140" label="节点"/>
      <el-table-column prop="handleTime" width="150" label="处理时间" align="center"/>
    </el-table>
    <div style="margin-top: 16px; overflow: hidden; float: right">
      <el-pagination
          background
          class="page"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "HandledList",
    components: { VmSearch },
    data() {
      return {
        handleList: [
          {
            value: -1,
            label: "全部",
          },
          {
            value: 1,
            label: "同意",
          },
          {
            value: 3,
            label: "退回",
          },
          {
            value: 4,
            label: "分配",
          },
          {
            value: 5,
            label: "转交",
          },
        ],
        typeList: [],
        exportLoading: false,
        nodeList: [],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                picker.$emit("pick", new Date());
              },
            },
            {
              text: "昨天",
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24);
                picker.$emit("pick", date);
              },
            },
            {
              text: "一周前",
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", date);
              },
            },
          ],
        },
        filter: {
          filter: "",
          formName: "",
          handlerName: "",
          billNo: "",
          nodeText: "",
          handleResult: -1,
          handledTimeStart: "",
          handledTimeEnd: "",
        },
        status: "empty",
        total: 0,
        pageSize: 10,
        currentPage: 1,
        tableData: [],
      };
    },
    mounted() {
      this.getTypeList();
      this.filter.handledTimeStart = this.$moment().subtract(1, "months").format("YYYY-MM-DD");
      this.filter.handledTimeEnd = this.$moment().format("YYYY-MM-DD");
    },
    methods: {
      // 获取单据类型
      getTypeList() {
        this.$http.get("basic", "workflows/formType").then((res) => {
          this.typeList = res;
          if (this.typeList) {
            this.filter.formName = this.typeList[0].formName;
            this.getList(1);
            this.getNodeList();
          }
        });
      },
      // 根据单据类型获取处理节点
      getNodeList() {
        let formName = "";
        if (this.filter.formName !== "RejectBill" && this.filter.formName !== "DeliveryNote") {
          if (this.filter.formName === "BusinessApplication") {
            formName = "wf" + this.filter.formName;
          } else {
            formName = "wf" + this.filter.formName + "Application";
          }
        } else {
          formName = this.filter.formName;
        }
        this.$http.get("basic", `workflows/node/${formName}`).then((res) => {
          this.nodeList = res;
        });
      },
      // 切换单据类型
      formNameChange() {
        this.getList(1);
        this.getNodeList();
      },

      getList(pageNum) {
        this.status = "loading";
        if (pageNum > 0) {
          this.currentPage = pageNum;
        }
        let formName = "";
        if (this.filter.formName !== "RejectBill" && this.filter.formName !== "DeliveryNote") {
          if (this.filter.formName === "BusinessApplication") {
            formName = "wf" + this.filter.formName;
          } else {
            formName = "wf" + this.filter.formName + "Application";
          }
        } else {
          formName = this.filter.formName;
        }
        let params = {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          type: formName,
          nodeText: this.filter.nodeText,
          handleResult: this.filter.handleResult,
          filter: this.filter.filter,
          handledTimeStart: this.filter.handledTimeStart,
          handledTimeEnd: this.filter.handledTimeEnd,
          billNo: this.filter.billNo,
          handlerName: this.filter.handlerName,
        };
        //单据类型为订单
        if (this.filter.formName === "SaleOrder") {
          this.$http.post("basic", "applications/handled/list/wfSaleOrderApplication", params).then((data) => {
            this.tableData = data.records;
            this.total = data.total;
            if (this.total === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          });
        } else if (this.filter.formName === "BusinessApplication") {
          // 单据类型为商务申请
          this.$http.post("basic", "applications/handled/list", params).then((res) => {
            this.tableData = res.data.records;
            this.total = res.data.total;
            if (this.total === 0) {
              this.status = "empty";
            } else {
              this.status = "finish";
            }
          });
        }
      },

      handleCurrentChange(pageNum) {
        this.getList(pageNum);
      },

      handleSearchClick() {
        this.getList(1);
      },

      exportExcel() {
        this.exportLoading = true;
        let formName = "";
        if (this.filter.formName !== "RejectBill" && this.filter.formName !== "DeliveryNote") {
          if (this.filter.formName === "BusinessApplication") {
            formName = "wf" + this.filter.formName;
          } else {
            formName = "wf" + this.filter.formName + "Application";
          }
        } else {
          formName = this.filter.formName;
        }
        let params = {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          type: formName,
          nodeText: this.filter.nodeText,
          handleResult: this.filter.handleResult,
          filter: this.filter.filter,
          handledTimeStart: this.filter.handledTimeStart,
          handledTimeEnd: this.filter.handledTimeEnd,
          billNo: this.filter.billNo,
          handlerName: this.filter.handlerName,
        };
        this.$http
          .postForFile("basic", "applications/handled/export", params)
          .then((res) => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
